var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ComConfig", {
    attrs: { title: "弹窗-1", component_name: "6-1-pop-window-1", limit: 1 },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }